import request from '../utils/request'
export default {
	
	/*-------------------------------------------------------------人事 管理员 start-----------------------------------------------------------  */
	//人事-薪酬-公司部门列表 - 李旭
	getCompanyDepart({ ...params }) {
		return request({
			method: 'POST',
			url: `/org/selDepartList`,
			data: params
		})
	},
	//人事-薪酬-列表查看 - 搞翔龙
	getSalary({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/query`,
			data: params
		})
	},
	//人事-薪酬-填报 - 李旭  假的接口
	publishSalary({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/personnel/salary/publish`,
			params: params
		})
	},
	//人事-薪酬-填报 - 李旭  假的接口
	delSalary({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/delete`,
			data: params
		})
	},
	//人事-薪酬-详情 - 李旭
	getSalaryDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/detail`,
			data: params
		})
	},
	// 人事-薪酬-填报 - 搞翔龙
	saveSalaryDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------人事 管理员 end-----------------------------------------------------------  */
	/*-------------------------------------------------------------人事 研究奖金 start-----------------------------------------------------------  */
	//奖金-研究院-查看 - 李旭
	getResearchDepartBonus({...params}) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/researchDepartBonus/query`,
			data: params
		})
	},
	//奖金-研究院-填报 - 李旭
	saveResearchDepartBonus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/researchDepartBonus/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------人事 研究奖金 end-----------------------------------------------------------  */
	/*-------------------------------------------------------------人事 Boss start-----------------------------------------------------------  */
	//奖金-高管-查看 - 李旭
	getSeniorManagerBonus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/seniorManagerBonus/query`,
			data: params
		})
	},
	//奖金-高管-填报 - 李旭
	saveSeniorManagerBonus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/seniorManagerBonus/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------人事 Boss end-----------------------------------------------------------  */
	/*-------------------------------------------------------------人事 销售奖金 start-----------------------------------------------------------  */
	//奖金-研究院-查看 - 李旭
	getSaleBonus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/saleBonus/query`,
			data: params
		})
	},
	//奖金-销售-填报 - 李旭
	saveSaleBonus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/saleBonus/save`,
			data: params
		})
	},
	/* 3.0 */
	//人事-员工工资列表-查看-陈龙
	queryEmployeeSalaryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/queryEmployeeSalaryList`,
			data: params
		})
	},
	//人员-薪酬-修改员工调整人员平均月薪
	updateMonthlySalaryById({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/updateMonthlySalaryById`,
			data: params
		})
	},
	//人事-薪酬-查看
	queryPersonnelSalaryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/salary/queryPersonnelSalaryList`,
			data: params
		})
	},
	/* 3.0 -end */
	/*-------------------------------------------------------------人事 销售奖金 end-----------------------------------------------------------  */


	/*-------------------------------------------------------------薪酬 归口福利费 start---------------------------------------------------------  */
	//薪酬-归口福利费列表-查看
	queryPutUnderFeeList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/centralized/welfare/queryList`,
			data: params
		})
	},
	//薪酬-归口福利费-保存
	savePutUnderFeeList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/centralized/welfare/save`,
			data: params
		})
	},
	//薪酬-归口福利费-删除
	deletePutUnderFeeList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/centralized/welfare/delete`,
			data: params
		})
	},
	/*-------------------------------------------------------------薪酬 归口福利费 end-----------------------------------------------------------  */
}